import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import { Row,Col, Card, Form, Button, } from 'react-bootstrap';
import {Spin, message} from 'antd';
import {Helmet} from "react-helmet";
import {
  getls, integerIndMobile, lettersOnly, integerAadhar, integerKeyPress, decimalKeyPress, upperCase
} from '../../../utils';
import axios from 'axios';
import {Api} from '../../../utils/Variables';

import PsContext from '../../context/PsContext';

class UpdateTs extends Component{
	
	static contextType = PsContext;
	
	constructor(props){
		super(props);
		this.state = {
			showLoader: false,
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}
	
	componentDidMount(){
		
		/* this.context.updateHeader({
			top: false,
			title: 'Policy',
			back: true,
		}); */
		
	}
	
	componentWillUnmount(){
		
		//this.context.updateHeader({top: false});		
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		try{
			
			this.setState({showLoader: true});
			axios.post(Api.Url+'v1/settings/updatets',$("#frmUpdateTs").serialize()).then(res=>{
				if(res['data'].status=='1'){
					this.context.updateCompany(res['data'].data);
					message.success(res['data'].message || 'Success');
					this.setState({showLoader: false});
				}
				else{
					message.error(res['data'].message || 'Error');
					this.setState({showLoader: false});
				}
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	render(){

		return(
			<Spin spinning={this.state.showLoader} >
				<form
					action=""
					method="post"
					encType="multipart/form-data" 
					id="frmUpdateTs"
					onSubmit={this.handleFormSubmit} 
				>
				
					<input type="hidden" name="api" value={this.context.state.api} />
					
					<Row>
						<Col md={12} >
							<label>TS Value</label>
							<Form.Control
								type="number"
								step="any"
								size="sm"
								name="i__value"
								defaultValue={this.context.state.company.ts_value}
								required
							/>
						</Col>
					</Row>
					
					<Row className="mt-10" >
						<Col md={12} >
							<div className="text-right" >
								<Button
									type="submit"
									size="md"
									variant="success"
								>
									Update
								</Button>
							</div>
						</Col>
					</Row>
					
				</form>
			</Spin>
		);
	}
	
}
export default UpdateTs;
